import { useCallback, useContext, useEffect, useState } from 'react';

import { getMessages } from '@/generated/client/messages/messages';
import { ctxMessages } from '@/contexts/MessagesCtx';
import { rethrowIfNotClientException } from '@/utilities/throwableUtils';
import { DetailedMessage } from '@/generated/model';

function sortAndUnique(messages: DetailedMessage[] | undefined) {
  if (!messages) return messages;
  messages.sort((a, b) => a.sentStatus.timeMicros - b.sentStatus.timeMicros);
  return messages.filter((value, index) => {
    return messages.findIndex((x) => x.id === value.id) === index;
  });
}

export function useChatLoader(
  threadId: number | undefined,
  lastTimeMicros: number
): [DetailedMessage[] | undefined, boolean, boolean] {
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [value, setValue] = useState<DetailedMessage[] | undefined>(undefined);
  const [scroll, setScroll] = useState<boolean>(false);
  const ctx = useContext(ctxMessages);

  function resetValues() {
    setValue([]);
    setHasMore(false);
    setScroll(false);
  }

  const loadChat = useCallback(
    async (lastTimeMicros: number, scroll: boolean) => {
      try {
        if (!threadId) return;
        const response = await getMessages({
          lastTimeMicros,
          limit: 10,
          threadId,
        });
        let messages = response.data;
        if (!messages.length) {
          setHasMore(false);
          return [];
        }
        messages.reverse();

        // nem szep megoldas start
        // ha nagy a kepernyo akkor 10 msg eseten nem scrolloz ezert nincs infinite betoltes
        // ezert az elejen 2x 10-es toltunk be

        if (value === undefined) {
          const response2 = await getMessages({
            lastTimeMicros: messages[0].sentStatus.timeMicros,
            limit: 10,
            threadId,
          });
          const messages2 = response2.data;
          messages2.reverse();

          messages = [...messages2, ...messages];
        }

        setHasMore(value === undefined ? messages.length === 20 : messages.length === 10);
        // nem szep megoldas stop

        setValue((old) => (old ? sortAndUnique([...messages, ...old]) : messages));
        setScroll(scroll);
      } catch (error) {
        resetValues();
        rethrowIfNotClientException(error);
      }
    },
    [threadId]
  );

  useEffect(() => {
    if (threadId && lastTimeMicros) {
      void loadChat(lastTimeMicros, value === undefined); // ha elso betoltes akkor scroll
    } else {
      console.log('this should not happen');
      setValue(undefined);
      setHasMore(false);
    }
  }, [threadId, lastTimeMicros, loadChat]);

  useEffect(() => {
    if (ctx && ctx.sentMessage) {
      setTimeout(async () => {
        await loadChat(Date.now() * 1000, true); // ha uj uzenet irasa miatt toltunk akkor scroll
        // setScroll(true);
      }, 250);
      setValue((old) => (old ? sortAndUnique([...old, ctx.sentMessage!]) : [ctx.sentMessage!])); // FIXME miert bang ?
      ctx.setSentMessage(undefined);
    }

    if (ctx && ctx.newMessages) {
      if (!threadId) return;
      setValue((o) => {
        const oldValue = o ?? [];
        const newMessages = ctx.newMessages.get(threadId) ?? [];

        // newMessages = newMessages.filter(message => message.type !== 'sent');

        return sortAndUnique([...oldValue, ...newMessages]);
      });
      setScroll(true);
    }
  }, [ctx, threadId, loadChat]);

  return [value, hasMore, scroll];
}
